// extracted by mini-css-extract-plugin
export default {"logoutButton":"_1FNVf8EL-G5tOobXJlMfYQ=="};